// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2TGku","main":"layout-module--main--2yme8"};